import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAlertSeverityDistributionRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
});

const GetAlertSeverityDistributionResponseDtoSchema = z.object({
  facility: z.object({
    high: z.number(),
    medium: z.number(),
    low: z.number(),
  }),
  market: z.object({
    high: z.number(),
    medium: z.number(),
    low: z.number(),
  }),
});

export type GetAlertSeverityDistributionRequestDto = z.infer<
  typeof _GetAlertSeverityDistributionRequestDtoSchema
>;
export type GetAlertSeverityDistributionResponseDto = z.infer<
  typeof GetAlertSeverityDistributionResponseDtoSchema
>;

export const getAlertSeverityDistribution = (
  params: GetAlertSeverityDistributionRequestDto,
  config?: AxiosRequestConfig<GetAlertSeverityDistributionRequestDto>
) => {
  const { facilityId, ...otherParams } = params;

  return api
    .get(
      `market-intelligence/facilities/${facilityId}/alert-severity-distribution`,
      { params: otherParams, ...config }
    )
    .then(responseContract(GetAlertSeverityDistributionResponseDtoSchema));
};
